import React from "react";
import { WrapWordP, WordP, PointTime, PointTimeStyles } from './Style'
import { Tooltip } from "@mui/material";
import { errorHooks } from "./ErrorTypes";

const Word = (props) => {
    const { isTranscriptionWord, tooltipPlacement, small, error, removed, minorError, customStatus, viewResults, is_time_point_word, time_point, transcription, word_def_text } = props

    const getTooltipTitle = errorHooks.useGetTooltipTitle()

    let tooltipContent = getTooltipTitle(error, minorError, removed, customStatus)

    return (
        <WrapWordP isTranscriptionWord={isTranscriptionWord} $removed={removed} $minorError={minorError} $error={error} $customStatus={customStatus}>
            {viewResults && is_time_point_word &&
                <PointTimeStyles isTopMode>{time_point}</PointTimeStyles>}
            <Tooltip title={tooltipContent} placement={tooltipPlacement || "top"}>
                <WordP small={small} $error={error}>
                    {transcription || word_def_text}
                </WordP>
            </Tooltip>
        </WrapWordP>
    )
}

export default Word